import AiSummaryIcon from "../../../assets/svg/ai-summary-icon";
import FormIcon from "../../../assets/svg/form-icon";
import CheckboxCheckedIcon from "../../../assets/svg/checkbox-checked-icon";
import CommunicationsToggleIcon from "../../../assets/svg/communications-toggle-icon";
import GalleryIcon from "../../../assets/svg/gallery-icon";
import InfoBtnIcon from "../../../assets/svg/info-btn-icon";
import LeadCommentIcon from "../../../assets/svg/lead-comment-icon";
import NoteIcon from "../../../assets/svg/note-icon";
// import PoundIcon from "../../../assets/svg/pound-icon";
import TasksIcon from "../../../assets/svg/tasks-icon";
import TemplatesIcon from "../../../assets/svg/templates-icon";
import ViewingsIcon from "../../../assets/svg/viewings-icon";
import ContactsIcon from "../../../assets/svg/contacts-icon";
import DealIcon from "../../../assets/svg/deal-icon";

export const CRM_LEAD_DETAILS_RIGHT_PANEL_SIDEBAR_ITEMS = [
  {
    id: "ai-summary",
    configKey: "ai_summary",
    label: "AI Summary",
    icon: AiSummaryIcon,
  },
  {
    id: "form-submissions",
    configKey: "form_submissions",
    label: "Form Submissions",
    icon: FormIcon,
  },
  {
    id: "notes",
    configKey: "notes",
    label: "Notes",
    icon: NoteIcon,
  },
  {
    id: "lead_comment",
    configKey: "lead_comment",
    label: "Lead Comment",
    icon: LeadCommentIcon,
  },
  {
    id: "tasks",
    configKey: "tasks",
    label: "Tasks",
    icon: TasksIcon,
    showCount: true,
    tagExtraClass: {
      primary:
        "bg-verba-red-alert dark:bg-verba-red-alert-dk text-fixed-white dark:text-fixed-white-dk",
      secondary:
        "bg-fixed-white dark:bg-fixed-white-dk text-deposit-requested dark:text-deposit-requested-dk",
    },
  },
  {
    id: "communication-toggles",
    configKey: "toggles",
    label: "Toggles",
    icon: CommunicationsToggleIcon,
  },
  {
    id: "sources",
    configKey: "sources",
    label: "Sources",
    icon: InfoBtnIcon,
  },
  {
    id: "templates",
    configKey: "templates",
    label: "Templates",
    icon: TemplatesIcon,
  },
  {
    id: "viewings",
    configKey: "viewings",
    label: "Viewings",
    icon: ViewingsIcon,
    showCount: true,
    tagExtraClass: {
      primary:
        "bg-tasks-scheduled dark:bg-tasks-scheduled-dk text-fixed-white dark:text-fixed-white-dk",
      secondary:
        "bg-fixed-white dark:bg-fixed-white-dk text-deposit-requested dark:text-deposit-requested-dk",
    },
  },
  {
    id: "attachments",
    configKey: "attachments",
    label: "Attachments",
    icon: GalleryIcon,
  },
  {
    id: "checklist",
    configKey: "checklist",
    label: "Checklist",
    icon: CheckboxCheckedIcon,
  },
  {
    id: "contacts",
    configKey: "contacts",
    label: "Contacts",
    icon: ContactsIcon,
    showCount: true,
    tagExtraClass: {
      primary:
        "bg-verba-blue dark:bg-verba-blue-dk text-fixed-white dark:text-fixed-white-dk",
      secondary:
        "bg-fixed-white dark:bg-fixed-white-dk text-deposit-requested dark:text-deposit-requested-dk",
    },
  },
  {
    id: "bookings",
    configKey: "bookings",
    label: "Bookings",
    icon: DealIcon,
  },
];
